__webpack_require__.p = "https://cdn.sheetgo.com/webapp/prod/prod.candidate.2.6.30-penguin-mafia-update/";